import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

export default function PhotoSwipeService() {

    this.init = function (photosElement, images, index) {

        var options = {
            index: index,
            closeElClasses: [],
            history: false,
            focus: false,
            zoomEl: false,
            tapToClose: false,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            clickToCloseNonZoomable: false,
            showAnimationDuration: 0,
            hideAnimationDuration: 0,
        };

        return new PhotoSwipe(photosElement, PhotoSwipeUI_Default, images, options);
    };
}
